import { Deserializable } from './deserializable.model';

export class SubscriptionAccount implements Deserializable<any, SubscriptionAccount> {
  constructor(public url?: string) {}

  deserialize(input: any): SubscriptionAccount {
    if (input == null) {
      return null;
    }

    this.url = input.url;

    return this;
  }
}
